import { loadablePage } from 'src/utils/loadable';

export default loadablePage(
  () =>
    import(
      /* webpackChunkName: "SearchCriteriaModal" */ /* webpackPrefetch: true */
      './SearchCriteriaModal.component'
    ),
);
